/**
 * Solution Constants
 * Stores information related to Solutions.
 */
export const SolutionConstants = Object.freeze({
    STATE: {
        CONTRACTOR_ASSIGNED: 'contractor_assigned',
        CONTRACTOR_CONFIRMED: 'contractor_confirmed',
        CONTRACTOR_REJECTED: 'contractor_rejected',
        CONTRACT_CREATED: 'contract_created',
        CANCELED: 'canceled',
        COMPLETED: 'completed',
    }
})